export default "__VITE_ASSET__DPiRHm6T__"